import { useMutation } from "@tanstack/react-query";
import { useSessionJWT } from "utils";
import { updateAccountInfo } from "./index.js";

export default function useUpdateAccountInfo() {
  const { sessionJWT } = useSessionJWT();
  return useMutation({
    mutationFn: (formData) => updateAccountInfo(sessionJWT, formData)
  });
}
